import Surface from '@storeblocks/surface';
import styled from 'styled-components';

export const InsuranceInfoCardSurface = styled(Surface)`
  margin-bottom: var(--spacer-m);
  align-self: baseline;
  & a {
    color: var(--color-on-background);
  }
`;

export const InsuranceInfoCardWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

interface InsuranceInfoCardContainerProps {
  hasIcon?: boolean;
}

export const InsuranceInfoCardContainer = styled.div<InsuranceInfoCardContainerProps>`
  display: flex;
  padding: 24px 0px 24px 24px;
`;

export const InsuranceInfoCardContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  h4 {
    line-height: normal;
    margin-bottom: 16px;
  }
`;

export const InsuranceInfoCardActionBar = styled.div`
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const InsuranceInfoCardFooter = styled.div`
  display: block;
  padding: 16px 24px 24px;
`;
